var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7V2H22V22H13V7ZM11 6V1C11 0.447716 11.4477 0 12 0H23C23.5523 0 24 0.447715 24 1V23C24 23.5523 23.5523 24 23 24H12H1C0.447715 24 0 23.5523 0 23V7C0 6.44772 0.447715 6 1 6H11ZM11 8H2V22H11V8ZM5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H5ZM4 15C4 14.4477 4.44772 14 5 14H8C8.55228 14 9 14.4477 9 15C9 15.5523 8.55228 16 8 16H5C4.44772 16 4 15.5523 4 15ZM5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12H8C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10H5ZM16 17C15.4477 17 15 17.4477 15 18C15 18.5523 15.4477 19 16 19H19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17H16ZM15 14C15 13.4477 15.4477 13 16 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H16C15.4477 15 15 14.5523 15 14ZM16 9C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11H19C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9H16ZM15 6C15 5.44772 15.4477 5 16 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H16C15.4477 7 15 6.55228 15 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.aed0e00d.svg";
export { ForwardRef as ReactComponent };